export const REMOTE_FREQUENCY = Object.freeze({
    FULL_TIME: 'fullTime',
    REGULARLY: 'regularly',
    OCCASIONALY: 'occasionally',
    NEVER: 'never'
});
